import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { WorkflowService } from 'src/app/core/services/workflow.service';
import { Workflow } from 'src/app/shared/models/systems/workflow.model';

@Component({
  selector: 'app-workflow-manager',
  templateUrl: './workflow-manager.component.html',
  styleUrls: ['./workflow-manager.component.css']
})
export class WorkflowManagerComponent implements OnInit {
  private ngUnsubscribe = new Subject();

  @Input() dto:WorkFlowManagerDto;

  workflow: Workflow;

  workflowLoaded: boolean;

  constructor(private workflowService: WorkflowService) { }

  ngOnInit(): void {
    this.workflowService.get(this.dto.idTipoFlujoTrabajo, this.dto.idEmpresa, this.dto.idResponsableServicio)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(workflow=>{
        this.workflow = workflow;
        this.workflowLoaded = true;
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}

export class WorkFlowManagerDto{
  idTipoFlujoTrabajo: number;
  idEmpresa?: number;
  idResponsableServicio?: number; 
  data: any;
}
